import { actions } from './config';
import { useOverrides } from '../../store';
import { Cookie } from '@libs/common-next';
import css from './actions.module.scss';

export const Actions = () => {
    const { setOverride } = useOverrides();

    const onClick = (type: string) => () => {
        if (type === 'reload') return window.location.reload();

        Cookie.remove('x-petm-override');
        setOverride({});
    };

    return (
        <>
            {Object.entries(actions).map(([type, action]) => (
                <div key={action.text} className={css.action}>
                    <button className={css.title} onClick={onClick(type)}>
                        <span>{action.icon}</span>
                        {action.text}
                    </button>
                    <span>{action.subtitle}</span>
                </div>
            ))}
        </>
    );
};
